import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import AnimatedSection from './AnimatedSection';
import { HandDrawnDivider } from './DecorativeElements';

const Gallery = () => {
  const { language } = useLanguage();
  const t = translations[language];

  useEffect(() => {
    // Load Elfsight widget script
    const script = document.createElement('script');
    script.src = 'https://apps.elfsight.com/p/platform.js';
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[src="https://apps.elfsight.com/p/platform.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <section id="gallery" className="section-padding bg-warm-beige texture-overlay">
      <div className="container mx-auto">
        <AnimatedSection animation="fadeInUp">
          <div className="text-center mb-16">
            <h2 className="section-heading">{t.gallery.title}</h2>
            <HandDrawnDivider />
          </div>
        </AnimatedSection>
        
        <AnimatedSection animation="fadeIn" delay={200}>
          <div className="elfsight-app-4a959e8b-9faa-4322-8758-05ba543d94e1"></div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Gallery;
